import React, { FC } from 'react'
import styled from 'styled-components'
import { Icon } from 'components/base-ui'
import { Fonts } from 'components/base-ui'

export interface Menu {
  testId?: string
  name: string
  icon: string
  active: boolean
  path: string
}

interface Props {
  menuList: Menu[]
  onClickMenu: (menu: Menu) => void
}

const Footer: FC<Props> = ({ menuList, onClickMenu }) => {
  return (
    <Wrapper>
      <MenuWrapper>
        {menuList.map((menu, index) => (
          <MenuItem $active={menu.active} key={index} onClick={() => onClickMenu(menu)} data-testid={menu.testId}>
            <Icon name={menu.icon} size="19px" />
            <MenuText>{menu.name}</MenuText>
          </MenuItem>
        ))}
      </MenuWrapper>
    </Wrapper>
  )
}

export default Footer

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => theme.spacing['2XS']};
  row-gap: ${({ theme }) => theme.spacing['3XL']};
  border-top: ${({ theme }) => theme.spacing['XL']};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px -2px 10px #f1f2f6;
`

const MenuWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  column-gap: 5px;
`

export const MenuItem = styled.div<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 1px;
  padding-top: ${({ theme }) => theme.spacing['3XS']};
  width: 50%;
  height: 44px;
  border-radius: ${({ theme }) => theme.radius.md};
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.white};
  ${({ $active, theme }) =>
    $active &&
    `
    color: ${theme.colors.white};
    background-color: ${theme.colors.primary};
  `}
`

export const MenuText = styled(Fonts.SmallTitleRegular)`
  font-size: 11px;
`
